import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { QuinielaJugada } from 'src/app/models/quiniela-jugada';
import { Partido } from 'src/app/models/partido';
import { Jugador } from 'src/app/models/jugador';
import { QuinielaJugadaService } from 'src/app/services/quiniela-jugada.service';
import { PartidosService } from 'src/app/services/partidos.service';
import { JugadorService } from 'src/app/services/jugadores.service';

@Component({
  selector: 'app-partido-page',
  templateUrl: './partido-page.component.html',
  styleUrls: ['./partido-page.component.css']
})
export class PartidoPageComponent implements OnInit {
  isLoading = false;
  partidos: Array<QuinielaJugada> = [];
  jugadores: Array<Jugador> = [];
  partido: Partido;
  idPartido: string;
  participantes = [];
  porcentaje = new Object();

  constructor(
    private QuinielaJugadaService: QuinielaJugadaService,
    private PartidosService: PartidosService,
    private JugadoresService: JugadorService,
    private router: Router,
    private rutaActiva: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    // Obtener el ID del Partido
    this.idPartido = this.rutaActiva.snapshot.params.id;

    // Obtener todos los partidos de ese ID
    this.getAllPartidos();
  }

  getAllPartidos(): void {
    this.isLoading = true;
    this.QuinielaJugadaService.getAllPartidosJugadosByIdPartido(this.idPartido).subscribe((items) => {
      // Setting up quinielas jugadas
      this.partidos = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as QuinielaJugada)
      );
      console.log(this.partidos)
      // Obtener la Info del Partido
      this.getInfoPartido();
    });
  }

  getInfoPartido(): void {
    this.PartidosService.getPartido(this.idPartido).subscribe((item) => {
      this.partido = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
      console.log("Información del Partido: ", this.partido)
      // Obtener todos los Jugadores
      this.getAllJugadores();
    });
  }

  getAllJugadores(): void {
    this.JugadoresService.getAllJugadoresByIdQuiniela(this.partido.idQuiniela).subscribe((items) => {
      // Setting up jugadores
      this.jugadores = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Jugador)
      );

      // Array de Jugadores que estan confirmados
      const jugadoresConfirmados = [];
      // Filtrar para obtener solo los jugadores confirmados
      for (let jugador of this.jugadores) {
        if (jugador.confirmado) {
          jugadoresConfirmados.push(jugador)
        }
      }
      // Se ingresan los jugadores confirmados en this.jugadores
      this.jugadores = jugadoresConfirmados;

      // Imprimiendo los Jugadores de la Quieniela
      console.log(this.jugadores)
      // Generar los objetos con nombre y el partido
      this.generateObjetos();
    });
  }

  generateObjetos(): void {
    this.isLoading = true;
    // Limpiar Array
    this.participantes = [];

    // Objeto para calcular porcentajes
    const porcentaje = {
      total: 0,
      equipo1: 0,
      equipo2: 0,
      empate: 0,
      porcentajeEquipo1: 0,
      porcentajeEquipo2: 0,
      porcentajeEmpate: 0
    };

    // Generar los participntes uniendo los nombres con el partido especifico
    for (let partido of this.partidos) {
      for (let jugador of this.jugadores) {
        if (partido.id_jugador == jugador.$key) {
          // Sumar uno al total de jugadores
          porcentaje.total++;

          // Saber si puso a ganar, peder o a empatar
          if (parseInt(partido.resultado1) > parseInt(partido.resultado2)) { // Caso 1 Ganando el Equipo 1
            porcentaje.equipo1++;
          } else if (parseInt(partido.resultado1) < parseInt(partido.resultado2)) { // Caso 2 Ganando el Equipo 2
            porcentaje.equipo2++;
          } else if ((parseInt(partido.resultado1) - parseInt(partido.resultado2)) == 0) { // Caso 3 Ganando el Empate
            porcentaje.empate++;
          }

          // Creación del objeto nuevo con toda la información necesaria en la vista
          const participante = {
            $key: jugador.$key,
            nombre: jugador.nombre + " " + jugador.apellido.substr(0, 1) + ".",
            contrincante1: partido.contrincante1,
            resultado1: partido.resultado1,
            contrincante2: partido.contrincante2,
            resultado2: partido.resultado2,
            ppe: partido.ppe,
            ppr: partido.ppr
          };
          this.participantes.push(participante);
        }
      }
    }
    this.isLoading = false;
    console.log("Tabla: ", this.participantes)

    // Calcular los porcentajes
    porcentaje.porcentajeEquipo1 = (porcentaje.equipo1 * 100) / porcentaje.total;
    porcentaje.porcentajeEquipo2 = (porcentaje.equipo2 * 100) / porcentaje.total;
    porcentaje.porcentajeEmpate = (porcentaje.empate * 100) / porcentaje.total;
    // Obtener la parte entera sin tantos decimales
    porcentaje.porcentajeEquipo1 = Math.trunc(porcentaje.porcentajeEquipo1);
    porcentaje.porcentajeEquipo2 = Math.trunc(porcentaje.porcentajeEquipo2);
    porcentaje.porcentajeEmpate = Math.trunc(porcentaje.porcentajeEmpate);
    this.porcentaje = porcentaje;
    console.log("Porcentaje: ", porcentaje)
  }
}
